module.exports = __webpack_public_path__ + "static/18-richard-67151ea0c80e481ca9b279f8164ad21d.jpg";